import { masks, onlyNumbers } from 'components/label/masks'
import * as React from 'react'

import { MaskedField, MaskedFieldProps } from '../final-form'

export const ChaveAgendaOnlineField = (props: MaskedFieldProps) => {
  return <MaskedField mask={masks.chaveAgendaOnline} parse={onlyNumbers} {...props} />
}
